import { GetSubscriptionResponse, SourceType } from '@api';
import { useInfiniteQuery } from '@tanstack/react-query';
import { getSubscription } from '@terminal/services/event-alerts/event-alerts-service';
import { QUERY_KEY_EVENT_ALERT_SUBSCRIPTION } from './event-alerts-query-keys';

const DUMMY_SUBSCRIPTION: GetSubscriptionResponse = {
  source_id: 'dummy-source-id',
  source_type: 'scenario-insight',
  tracking_status: 'active',
  subscriptions: [
    {
      source_id: '06ddb8c1-9944-4e80-a2b5-8e478af2167a',
    },
    {
      source_id: '357bca06-a4ca-44fa-a859-e51e7fec9bbe',
    },
  ],
};

export const useGetSubscription = ({
  sourceType,
  sourceId,
  enabled = true,
  cache = true,
  useDummyData = false,
}: {
  sourceType: SourceType;
  sourceId?: string;
  enabled?: boolean;
  cache?: boolean;
  useDummyData?: boolean;
}) =>
  useInfiniteQuery({
    queryKey: [QUERY_KEY_EVENT_ALERT_SUBSCRIPTION, sourceId, sourceType],
    queryFn: ({ pageParam }) =>
      useDummyData
        ? Promise.resolve(DUMMY_SUBSCRIPTION)
        : getSubscription({
            sourceType,
            sourceId,
            next: pageParam ?? undefined,
          }),
    enabled,
    initialPageParam: null as string | null,
    getNextPageParam: (lastPage): string | null =>
      lastPage?.next_cursor ?? null,
    ...(cache ? {} : { staleTime: 0, gcTime: 0 }),
  });
